export interface SearchGotoSection {
    id: string;
    labelKey: string;
    subtitleKey: string;
    icon: string;
    route: string;
}

/**
 * Accesos directos a las secciones principales de la app para el estado
 * "IR A" del command palette (buscador del topbar). Lista curada a mano:
 * no existe hoy un catálogo de secciones "core" reutilizable — el menú
 * lateral real es 100% dinámico desde BD (`NavigationService`) y varía por
 * tenant, así que acoplarse a él sería más complejo de lo que pide el
 * ticket. Si el menú cambia, esta lista no se actualiza sola.
 */
export const SEARCH_GOTO_SECTIONS: SearchGotoSection[] = [
    { id: 'dashboard', labelKey: 'app.topbar.search.sections.dashboard', subtitleKey: 'app.topbar.search.sections.dashboard_sub', icon: 'pi pi-home', route: '/dashboard/list' },
    { id: 'persons', labelKey: 'app.topbar.search.sections.persons', subtitleKey: 'app.topbar.search.sections.bbdd_sub', icon: 'pi pi-user', route: '/persons/list' },
    { id: 'groups', labelKey: 'app.topbar.search.sections.groups', subtitleKey: 'app.topbar.search.sections.bbdd_sub', icon: 'pi pi-users', route: '/groups/list' },
    { id: 'institutions', labelKey: 'app.topbar.search.sections.institutions', subtitleKey: 'app.topbar.search.sections.bbdd_sub', icon: 'pi pi-building', route: '/institutions/list' },
    { id: 'positions', labelKey: 'app.topbar.search.sections.positions', subtitleKey: 'app.topbar.search.sections.bbdd_sub', icon: 'pi pi-briefcase', route: '/positions/list' },
    { id: 'events', labelKey: 'app.topbar.search.sections.events', subtitleKey: 'app.topbar.search.sections.events_sub', icon: 'pi pi-calendar', route: '/events/list' },
    { id: 'notifications', labelKey: 'app.topbar.search.sections.notifications', subtitleKey: 'app.topbar.search.sections.communications_sub', icon: 'pi pi-bell', route: '/communications/notifications/list' }
];
